module.exports = __webpack_public_path__ + "media/images/icon-logo-naver@3x-ed45c6ac4672533f1e366a54459e4506.png";